import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {PartitionOPEEnum} from "./PartitionOPEEnum";

/**
 * O Inner Class
 */
class O {
  id?: number;
}

/**
 * I Inner Class
 */
class I {
  id?: number;
  name!: string;
  parentId?: number;
  active!: boolean;
  notes?: string;

  additionalInfo?: PartitionAdditionalInfoDTO;
}

class PartitionAdditionalInfoDTO {
  address?: AddressDTO;
}

class AddressDTO {
  number?: string;
  street?: string;
  city?: string;
  cap?: string;
  telephone?: string;
  province?: string;
}

export class PutPartitionCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(PartitionOPEEnum.PutPartition);
    this.i = new I();
    this.o = new O();
  }
}
